import validate from 'validate.js'

const constraints = {
    
  councelorId: {
    presence: true
  },
  studentId: {
    presence: false
  },
  lessonId: {
    presence: true
  },
  parentId: {
    presence: false
  }
}

export default (data) => {
  return validate(data, constraints)
}
